import { render, staticRenderFns } from "./MyInvestStatus.vue?vue&type=template&id=4fe1dd04&"
import script from "./MyInvestStatus.vue?vue&type=script&lang=js&"
export * from "./MyInvestStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports